import { Typography } from '@mui/material';
import { BaseTypographyConfig } from 'core/components/typography/BaseTypograhyConfig';
import React from 'react';

function BaseTypography({
	children = null,
	variant = BaseTypographyConfig.defaultVariantType,
	color = BaseTypographyConfig.defaultColor,
	onClick = null,
	styles = {},
	...props
}) {
	return (
		<Typography
			variant={variant}
			color={color}
			onClick={onClick}
			sx={styles}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
		>
			{children}
		</Typography>
	);
}

export default BaseTypography;
